import React from 'react'
import Navbar from './../../components/Navbar';
import Footer from './../../components/Footer';
import { LinkWhiteHoverOrange } from '../../components/StyledComponents';
import { PrimaryButton } from '../../components/StyledButtons';
import { useTranslation } from 'react-i18next';

const BlogDetails = (props) => {
    const { t } = useTranslation()

    return (
        <div className='blog-details bg-primary'>
            <Navbar />
            <div className='blog-details-content container pt-200 pb-50'>
                <div className='px-lg-120'>
                    <p className='font-48 text-white font-weight-semi-bold'>{props.title}</p>
                    <div className='pt-50'>
                        <img src={props.image} alt="" className='img-responsive' />
                    </div>
                    {props.children}
                    <div className='pt-50'>
                        <p className='text-white font-weight-semi-bold'>{t('blog.other-articles-that-you-may-also-like')}</p>
                        <ul className='list-unstyled'>
                            {props.randomLink.map((link, index) => (
                                <li className='checked-line' key={link.index}>
                                    <LinkWhiteHoverOrange href={`/blog${link.url}`}>{link.title}</LinkWhiteHoverOrange>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className='pt-50'>
                        <PrimaryButton>{t('button.schedule-discussion')}</PrimaryButton>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default BlogDetails